/**
 * Discount Offers Block - JavaScript
 * Handles copy-to-clipboard and variant price updates
 */

if (!customElements.get('discount-offers-block')) {
  class DiscountOffersBlock extends HTMLElement {
    constructor() {
      super();
      this.copiedDuration = 1500;
    }

    connectedCallback() {
      this.bindCopyButtons();
      this.bindVariantChange();
    }

    bindCopyButtons() {
      this.querySelectorAll('[data-copy-code]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const code = btn.dataset.copyCode;
          if (!code) return;

          this.copyToClipboard(code).then(() => {
            const textEl =
              btn.querySelector('[data-pill-text]') ||
              btn.closest('.do-coupon')?.querySelector('.do-coupon__code strong');

            if (textEl) {
              const original = textEl.textContent;
              textEl.textContent = window.theme?.strings?.copied || 'Copied!';
              btn.classList.add('is-copied');

              setTimeout(() => {
                textEl.textContent = original;
                btn.classList.remove('is-copied');
              }, this.copiedDuration);
            } else {
              btn.classList.add('is-copied');
              setTimeout(() => btn.classList.remove('is-copied'), this.copiedDuration);
            }
          });
        });
      });
    }

    copyToClipboard(text) {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
      }

      return new Promise((resolve, reject) => {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        document.body.appendChild(textarea);
        textarea.select();

        try {
          document.execCommand('copy');
          resolve();
        } catch (err) {
          reject(err);
        }

        document.body.removeChild(textarea);
      });
    }

    bindVariantChange() {
      const maxPercentage = parseFloat(this.dataset.maxPercentage) || 0;
      const priceEl = this.querySelector('[data-best-price]');

      if (!priceEl || !maxPercentage) return;

      document.addEventListener('variant:change', (e) => {
        if (!e.detail?.variant) return;

        const productId = this.dataset.productId;
        if (e.detail.productId && e.detail.productId != productId) return;

        const newPrice = e.detail.variant.price;
        const discountedPrice = Math.round(newPrice * (1 - maxPercentage));

        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          priceEl.textContent = Shopify.formatMoney(discountedPrice, window.theme?.moneyFormat);
        }
      });
    }
  }

  customElements.define('discount-offers-block', DiscountOffersBlock);
}
